import React, { useState, useRef, useEffect } from "react"
import { PiSortAscendingLight, PiSortDescendingLight } from "react-icons/pi"
import { CiSearch } from "react-icons/ci"
import { FaFileExcel, FaFilePdf } from "react-icons/fa"
import { ChevronLeft, ChevronRight, Search } from "lucide-react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { format, subDays, subMonths, startOfMonth, endOfMonth } from "date-fns";
import axios from "axios";
import { BaseUrl } from "../App"
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


function Staff_booking() {
  const [selectedOption, setSelectedOption] = useState("Today")
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"))
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"))
  const [showCalendars, setShowCalendars] = useState(false)
  const calendarRef = useRef(null)
  const [modalError, setModalError] = useState("") // New state for modal error
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tableData, setTableData] = useState([])
  const [sortedTable, setSortedTable] = useState([])
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" })
  const [searchQuery, setSearchQuery] = useState("")
  const [entriesPerPage, setEntriesPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [modalEntriesPerPage, setModalEntriesPerPage] = useState(5)
  const [modalCurrentPage, setModalCurrentPage] = useState(1)
  const [modalSearchQuery, setModalSearchQuery] = useState("")
  const [loading, setLoading] = useState(false);
  const [staffPaymentData, setStaffPaymentData] = useState({
    staff_ids: "",
    orderId: "",
    staffName: "",
    netTotal:"",
    amountPayable: "",
    advancePaid: "",
    Total: "",
  });
  // Fetch the staff payment data from API
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/staff_payment_details.php`,
          {
            action: "get_staff_all_payment_details",
            api_key: "1",
          }
        );
        console.log("axios response:", response); // Log the entire response
        const fetchedData = response.data.response;
        console.log("fetchedData (from API):", fetchedData, typeof fetchedData); // Log data and its type

        if (!Array.isArray(fetchedData)) {
          console.error("ERROR: fetchedData is NOT an array!");
          setTableData([]); // Set to an empty array as a fallback
          setSortedTable([]); // Also set sortedTable to avoid further errors
          return; // IMPORTANT: Exit the function to prevent further processing
        }

        setTableData(fetchedData);
        setSortedTable(fetchedData);

      } catch (error) {
        console.error("Error fetching staff payment data", error);
        setTableData([]); // Handle errors by setting state to an empty array
        setSortedTable([]);
      }
      finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {
    // Recalculate netTotal when amountPayable or advancePaid changes
    const netTotal = parseFloat(staffPaymentData.amountPayable) + parseFloat(staffPaymentData.advancePaid);
    setStaffPaymentData((prevData) => ({
      ...prevData,
      Total: netTotal.toFixed(2),  // Update netTotal with 2 decimal places
    }));
  }, [staffPaymentData.amountPayable, staffPaymentData.advancePaid]);

  useEffect(() => {
    setSortedTable(tableData);
  }, [tableData]);
 
  // const handleSavePayment = async () => {
  //   setLoading(true);
  //   setModalError(""); // Reset error before new request
  //   try {
  //     const netTotal = parseFloat(staffPaymentData.amountPayable || 0) + parseFloat(staffPaymentData.advancePaid || 0);
      
  //     const response = await axios.post(`${BaseUrl}/backend/api/add_staff_payment.php`, {
  //       action: "staff_payment_save",
  //       api_key: "1",
  //       staff_pymnt_id: staffPaymentData.staff_ids,
  //       sp_staff_amount: staffPaymentData.amountPayable,
  //       sp_staff_advance_paid: staffPaymentData.advancePaid,
  //       sp_staff_net_total: netTotal.toFixed(2),
  //       staff_pymnt_orderid: staffPaymentData.orderId,
  //     });

  //     if (response.data.status === "true") {
  //       setSuccessMessage("Payment saved successfully");
        
  //       const newPayment = response.data.newPayment || {
  //         staff_ids: staffPaymentData.staff_ids,
  //         order_id: staffPaymentData.orderId,
  //         staff_name: staffPaymentData.staffName,
  //         net_total: netTotal.toFixed(2),
  //         amount_payable: staffPaymentData.amountPayable,
  //         advance_paid: staffPaymentData.advancePaid,
  //       };
        
  //       setTableData(prevData => [...prevData, newPayment]);
  //       setSortedTable(prevData => [...prevData, newPayment]);
  //       closeModal();
  //     } else {
  //       // Set backend error message to show in modal
  //       setModalError(response.data.message || "Failed to save payment");
  //     }
  //   } catch (error) {
  //     console.error("Error saving payment", error);
  //     setModalError("Error saving payment: " + error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSavePayment = async () => {
    setLoading(true);
    setModalError("");
    try {
      const netTotal = parseFloat(staffPaymentData.amountPayable || 0) + parseFloat(staffPaymentData.advancePaid || 0);
      
      const response = await axios.post(`${BaseUrl}/backend/api/add_staff_payment.php`, {
        action: "staff_payment_save",
        api_key: "1",
        staff_pymnt_id: staffPaymentData.staff_ids,
        sp_staff_amount: staffPaymentData.amountPayable,
        sp_staff_advance_paid: staffPaymentData.advancePaid,
        sp_staff_net_total: netTotal.toFixed(2),
        staff_pymnt_orderid: staffPaymentData.orderId,
      });

      if (response.data.status === "true") {
        setSuccessMessage("Payment saved successfully");
        
        const newPayment = {
          ...staffPaymentData,
          order_id: staffPaymentData.orderId,
          staff_name: staffPaymentData.staffName,
          net_total: netTotal.toFixed(2),
          amount_payable: staffPaymentData.amountPayable,
          advance_paid: staffPaymentData.advancePaid,
          commission_total: netTotal.toFixed(2) // Changed to use netTotal instead of amountPayable
        };

        // Update tableData immediately with the new payment
        setTableData(prevData => {
          const updatedData = prevData.map(row => 
            row.order_id === newPayment.order_id 
              ? { ...row, commission_total: newPayment.commission_total }
              : row
          );
          // If it's a new entry, add it; if it exists, it's already updated
          if (!updatedData.some(row => row.order_id === newPayment.order_id)) {
            return [...updatedData, newPayment];
          }
          return updatedData;
        });

        closeModal();
      } else {
        setModalError(response.data.message || "Failed to save payment");
      }
    } catch (error) {
      console.error("Error saving payment", error);
      setModalError("Error saving payment: " + error.message);
    } finally {
      setLoading(false);
    }
  };
  // Modified useEffect for Total calculation
  useEffect(() => {
    const total = (parseFloat(staffPaymentData.amountPayable || 0) + 
                  parseFloat(staffPaymentData.advancePaid || 0)).toFixed(2);
    setStaffPaymentData((prevData) => ({
      ...prevData,
      Total: total
    }));
  }, [staffPaymentData.amountPayable, staffPaymentData.advancePaid]);
 const handleSelect = (option) => {
    setSelectedOption(option)
    if (option === "Custom Range") {
      const lastMonthStart = format(startOfMonth(subDays(new Date(), 30)), "yyyy-MM-dd")
      const currentMonthEnd = format(new Date(), "yyyy-MM-dd")
      setStartDate(lastMonthStart)
      setEndDate(currentMonthEnd)
      setShowCalendars(true)
    } else {
      updateDateRange(option)
      setShowCalendars(false)
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendars(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])
  useEffect(() => {
    if (selectedOption === "Custom Range") {
      setShowCalendars(true)
    }
  }, [selectedOption])

   const updateDateRange = (option) => {
    let start, end
    const today = new Date()

    switch (option) {
      case "Today":
        start = end = today
        break
      case "Yesterday":
        start = end = subDays(today, 1)
        break
      case "Last 7 Days":
        start = subDays(today, 7)
        end = today
        break
      case "Last 30 Days":
        start = subDays(today, 30)
        end = today
        break
      case "This Month":
        start = startOfMonth(today)
        end = endOfMonth(today)
        break
      case "Last Month":
        const firstDayLastMonth = startOfMonth(subDays(today, 30))
        const lastDayLastMonth = endOfMonth(subDays(today, 30))
        start = firstDayLastMonth
        end = lastDayLastMonth
        break
      default:
        start = end = today
    }
    setStartDate(format(start, "yyyy-MM-dd"))
    setEndDate(format(end, "yyyy-MM-dd"))
  }
  const handleSort = (column) => {
    let direction = "asc"
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key: column, direction })
    const sortedData = [...tableData].sort((a, b) => {
      if (a[column] < b[column]) return direction === "asc" ? -1 : 1
      if (a[column] > b[column]) return direction === "asc" ? 1 : -1
      return 0
    })
    setSortedTable(sortedData)
  }
  const getSortIcon = (column) => {
    if (sortConfig.key !== column) {
      return <PiSortAscendingLight className="text-gray-500" />
    }
    return sortConfig.direction === "asc" ? <PiSortAscendingLight /> : <PiSortDescendingLight />
  }

  useEffect(() => {
    console.log("tableData updated:", tableData, typeof tableData);  // Check tableData's type
    setSortedTable(tableData);
  }, [tableData]);

  useEffect(() => {
    console.log("sortedTable updated:", sortedTable, typeof sortedTable); //Check sortedTable's type
  }, [sortedTable]);

  console.log("sortedTable before filter:", sortedTable, typeof sortedTable); // Type check here too!
  const filteredData = (sortedTable || []).filter(
    (row) =>
      (row?.S_name?.toLowerCase() ?? "").includes(searchQuery.toLowerCase()) ||
      (row?.App_Date?.toLowerCase() ?? "").includes(searchQuery.toLowerCase()) ||
      (row?.C_name?.toLowerCase() ?? "").includes(searchQuery.toLowerCase()) ||
      (row?.Status?.toLowerCase() ?? "").includes(searchQuery.toLowerCase()) ||
      (row?.Staff_name?.toLowerCase() ?? "").includes(searchQuery.toLowerCase())
  )
  const startIndex = (currentPage - 1) * entriesPerPage
  const paginatedData =
    entriesPerPage === "All" ? filteredData : filteredData.slice(startIndex, startIndex + entriesPerPage)
  const totalPages = Math.ceil(filteredData.length / entriesPerPage)
  const handleSearch = (e) => setSearchQuery(e.target.value)
  const handleEntriesChange = (e) => {
    setEntriesPerPage(e.target.value === "All" ? "All" : Number.parseInt(e.target.value, 10))
    setCurrentPage(1)
  }
  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1))
  const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages))
  const handlePageChange = (page) => setCurrentPage(page)

  // Modal functions
  const openModal = (row) => {
    console.log("Opening modal with row data:", row);
    setStaffPaymentData({
      staff_ids: row.staff_ids,
      orderId: row.order_id,
      staffName: row.staff_name,
      netTotal: row.net_total || "0", // Ensure netTotal is set from row data
      amountPayable: row.amount_payable || "0",
      advancePaid: row.advance_paid || "0",
      Total: (parseFloat(row.amount_payable || 0) + parseFloat(row.advance_paid || 0)).toFixed(2),
    });
    setModalError(""); // Reset error when opening modal
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false)
  const filteredModalData = Array.isArray(staffPaymentData) 
  ? staffPaymentData.filter((staff) =>
      staff.name.toLowerCase().includes(modalSearchQuery.toLowerCase())
    )
  : [];
  const modalStartIndex = (modalCurrentPage - 1) * modalEntriesPerPage
  const modalPaginatedData = filteredModalData.slice(modalStartIndex, modalStartIndex + modalEntriesPerPage)
  const modalTotalPages = Math.ceil(filteredModalData.length / modalEntriesPerPage)

  const handleExcelExport = () => {
    const columns = [
      " Order ID",
      "Service",
      "App Date",
      "Client Name",
      "Status",
      "Staff Name",
      "Net Total",
      "Commission Total",
    ];

    // Use filteredData here, as it's the data you're displaying
    const rows = filteredData.map((row) => [
      row?.order_id,
      row.service_name,
      row.booking_date_time,
      row.client_name,
      row.status,
      row.staff_name,
      row.net_total, 
      row.commission_total,
      
    // Include staff booking status
    ]);

    const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Table Data");
    XLSX.writeFile(wb, "table-data.xlsx");
  };
  // Export to Excel
  const handlePdfExport = () => {
    const doc = new jsPDF();

    const columns = [
      "Order ID",
      "Service",
      "App Date",
      "Client Name",
      "Status",
      "Staff Name",
      "Net Total",
      "Commission Total",
    ];

    // Use filteredData here, as it's the data you're displaying
    const rows = filteredData.map((row) => [
      row?.order_id,
      row.service_name,
      row.booking_date_time,
      row.client_name,
      row.status,
      row.staff_name,
      row.net_total, 
      row.commission_total,
    ]);

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      margin: { horizontal: 10 },
      headStyles: {
        fillColor: [0, 123, 255],
        textColor: 255,
      },
    });

    doc.save("staffPaymentData.pdf");
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="container mx-auto px-4 md:px-6 lg:px-8 xl:px-24 py-6">
     {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <div className="text-2xl font-bold p-4">
        <span>Staff Booking Details and Payment</span>
      </div>

      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
        <div className="flex flex-col sm:flex-row items-center">
          <div className="relative">
            <input
              type="text"
              placeholder="Search Staff..."
              value={searchQuery}
              onChange={handleSearch}
              className="p-3 lg:w-full sm:w-80 md:w-96 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300 pl-10"
            />
            <CiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
          </div>
        </div>
        <div className="flex gap-4 flex-col sm:flex-row items-center mt-4 sm:mt-0">
          <div className="flex items-center">
            <button
              className="bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
              onClick={handleExcelExport}
            >
              <FaFileExcel className="text-sm sm:text-lg" />
              Excel
            </button>

            <button
              className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold text-sm sm:text-base py-1 sm:py-2 px-2 sm:px-4 rounded-full shadow-lg hover:shadow-xl hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 flex items-center gap-2"
              onClick={handlePdfExport}
            >
              <FaFilePdf className="text-sm sm:text-lg" />
              PDF
            </button>
          </div>

          <div className="flex items-center gap-2 sm:mt-0">
            <span>show</span>
            <select
              value={entriesPerPage}
              onChange={handleEntriesChange}
              className="p-3 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value="All">All</option>
            </select>
            <span>entries</span>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto mt-6">
        <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg hidden sm:table">
          <thead className="bg-blue-100 text-left">
            <tr>
              <th className="px-4 py-2 border-b cursor-pointer">#</th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("S_name")}
              >
                <div className="flex items-center gap-2">
                  S_name {getSortIcon("S_name")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("App_Date")}
              >
                <div className="flex items-center gap-2">
                  App_Date {getSortIcon("App_Date")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("C_name")}
              >
                <div className="flex items-center gap-2">
                  C_name {getSortIcon("C_name")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("Status")}
              >
                <div className="flex items-center gap-2">
                  Status {getSortIcon("Status")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("Staff_name")}
              >
                <div className="flex items-center gap-2">
                  Staff_name {getSortIcon("Staff_name")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("Net_Total")}
              >
                <div className="flex items-center gap-2">
                  Net_Total {getSortIcon("Net_Total")}
                </div>
              </th>
              <th
                className="px-4 py-2 border-b cursor-pointer"
                onClick={() => handleSort("Com_Total")}
              >
                <div className="flex items-center gap-2">
                  Com_Total {getSortIcon("Com_Total")}
                </div>
              </th>
              <th className="px-4 py-2 border-b">Actions</th>
            </tr>
          </thead>
          <tbody>
            {sortedTable.length > 0 ? (
              paginatedData.map((row, index) => (
                <tr key={index} className="border-t border-gray-200">
                  <td className="px-4 py-2 border-b">{row?.order_id}</td>
                  <td className="px-4 py-2 border-b">{row.service_name}</td>
                  <td className="px-4 py-2 border-b">
                    {row.booking_date_time}
                  </td>
                  <td className="px-4 py-2 border-b">{row.client_name}</td>
                  <td className="px-4 py-2 border-b">{row.status}</td>
                  <td className="px-4 py-2 border-b">{row.staff_name}</td>
                  <td className="px-4 py-2 border-b">{row.net_total}</td>
                  <td className="px-4 py-2 border-b">{row.commission_total}</td>
                  <td className="px-4 py-2 border-b text-center">
                        {!row.commission_total ? (
                          <button
                            onClick={() => openModal(row)}
                            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                          >
                            Staff Payment
                          </button>
                        ) : (
                          <span className="text-green-600 font-lg">Payment Complete</span>
                        )}
                      </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="sm:hidden">
  {sortedTable.length > 0 ? (
    paginatedData.map((row, index) => (
      <div
        key={row?.order_id}
        className="bg-white border border-gray-200 shadow-sm rounded-lg mb-4 p-4 
                  transition-all duration-200 hover:shadow-md mx-2"
      >
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3 gap-2">
          <div className="font-semibold text-base text-gray-800 truncate w-full sm:w-auto">
            {row.service_name}
          </div>
          <div className="text-xs text-gray-500 whitespace-nowrap">
            {row.booking_date_time}
          </div>
        </div>

        <div className="space-y-2 text-sm text-gray-700">
          <div className="flex flex-col">
            <span className="font-medium">Client:</span>
            <span className="text-gray-600">{row.client_name}</span>
          </div>
          
          <div className="flex flex-col">
            <span className="font-medium">Status:</span>
            <span className="text-gray-600">{row.status}</span>
          </div>
          
          <div className="flex flex-col">
            <span className="font-medium">Staff Name:</span>
            <span className="text-gray-600">{row.staff_name}</span>
          </div>
          
          <div className="flex flex-col">
            <span className="font-medium">Net Total:</span>
            <span className="text-gray-600">{row.net_total}</span>
          </div>
          
          <div className="flex flex-col">
            <span className="font-medium">Commission Total:</span>
            <span className="text-gray-600">{row.commission_total}</span>
          </div>
        </div>

        <div className="mt-4 flex justify-end">
      
                        {!row.commission_total ? (
                          <button
                            onClick={() => openModal(row)}
                            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
                          >
                            Staff Payment
                          </button>
                        ) : (
                          <span className="text-green-600 font-semibold">Payment Complete</span>
                        )}
                      
        </div>
      </div>
    ))
  ) : (
    <div className="text-center py-6 text-gray-500 text-sm mx-2">
      No data available
    </div>
  )}
</div>
      </div>
      <div className="flex flex-col sm:flex-row sm:justify-between items-center mt-4 gap-3 w-full">
  {/* Entries Info */}
  <div className="text-sm text-gray-600 text-center sm:text-left w-full sm:w-auto">
    <span>Showing </span>
    <span>1</span>
    <span> to </span>
    <span>5</span>
    <span> of </span>
    <span>2</span>
    <span> entries</span>
  </div>

  {/* Pagination */}
  {entriesPerPage !== "All" && (
    <div className="flex flex-wrap justify-center sm:justify-end items-center space-x-1 w-full sm:w-auto">
      <button
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        className="px-3 py-1 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50 text-sm"
      >
        Previous
      </button>

      <div className="flex overflow-x-auto space-x-1">
        {[...Array(totalPages).keys()].map((page) => (
          <button
            key={page + 1}
            onClick={() => handlePageChange(page + 1)}
            className={`px-3 py-1 text-sm border ${
              currentPage === page + 1
                ? "bg-blue-500 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {page + 1}
          </button>
        ))}
      </div>

      <button
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        className="px-3 py-1 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50 text-sm"
      >
        Next
      </button>
    </div>
  )}
</div>


      {isModalOpen && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-none overflow-y-auto p-4 min-h-screen flex items-start justify-center z-50">
    <div className="relative w-full max-w-4xl bg-white rounded-lg shadow-xl mt-8 animate-in fade-in duration-200">
    {modalError && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-t relative">
                    <span className="block sm:inline">{modalError}</span>
                  </div>
                )}
      <div className="p-6 border-b flex justify-between items-center">
        <h3 className="text-xl font-semibold text-gray-900">
          Add Payment to Staff Account
        </h3>
        <button
          onClick={closeModal}
          className="text-gray-500 hover:text-gray-700 focus:outline-none"
        >
          ✖
        </button>
      </div>
      <div className="p-6">
        <div className="flex flex-col md:flex-row md:justify-between gap-4 mb-6">
        </div>
        <div className="overflow-x-auto">
          <table className="w-full table-auto border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                  Order ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                  Staff Name
                </th>
                
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                 Net Total
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                  Amount Payable
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                  Advance Paid
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900 border-x border-y border-gray-200">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr>
                <td className="px-4 py-3 text-sm text-gray-500 border-x border-y border-gray-200">
                  {staffPaymentData.orderId}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 font-medium border-x border-y border-gray-200">
                  {staffPaymentData.staffName}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 font-medium border-x border-y border-gray-200">
                  {staffPaymentData.netTotal}
                </td>
                <td className="px-4 py-3 border-x border-y border-gray-200">
                  <input
                    type="number"
                    value={staffPaymentData.amountPayable}
                    onChange={(e) =>
                      setStaffPaymentData({
                        ...staffPaymentData,
                        amountPayable: e.target.value,
                      })
                    }
                    className="w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                  />
                </td>
                <td className="px-4 py-3 border-x border-y border-gray-200">
                  <input
                    type="number"
                    value={staffPaymentData.advancePaid}
                    onChange={(e) =>
                      setStaffPaymentData({
                        ...staffPaymentData,
                        advancePaid: e.target.value,
                      })
                    }
                    className="w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                  />
                </td>

                <td className="px-4 py-3 border-x border-y border-gray-200">
                  <div className="px-4 py-3">
                    <label className="block text-sm font-medium text-gray-700">
                       Total
                    </label>
                    <input
                      type="number"
                      value={staffPaymentData.Total}
                      readOnly // Disable the user from editing net total manually
                      className="w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
        </div>
      </div>
      <div className="px-6 py-4 border-t bg-gray-50 rounded-b-lg flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
        <button
          onClick={closeModal}
          className="w-full sm:w-auto px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500"
        >
          Close
        </button>
        <button
          onClick={handleSavePayment} // Function to handle API call for saving
          className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-sm font-medium rounded-md text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
)}
    </div>
       
  </div>
  );
}

export default Staff_booking

